/**
 * @module interface
 */
import type { V2TimUserInfo } from './v2TimUserInfo';

export interface V2TIMMessageReaction {
    reactionID: string;
    totalUserCount?: number;
    partialUserList?: V2TimUserInfo[];
    reactedByMyself?: boolean;
}
